const Constants = {
    // Collections Name
    userCollection: "user_collection",
    adminCollection: "admin_collection",
    scoreCollection: "score_collection",
    paymentCollection: "payment_collection",
    categoryCollection: "category",
    subcategoryCollection: "sub_category",
    names: "names",
    trendingNames: "trending_names",
    slogan: 'slogan',
    sloganCategoryCollection: 'slogan_category',

    // filed name
    email: "email",
    password: "password",

    //regex
    emailRegex: /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/,

    // Erorr Messages
    emailErrorMessage: "Email is required.",
    passwordErrorMessage: "Password is required.",
    validEmail: "Please enter valid email.",
    userNotExist: "User does not exist.",
    incorrectPassword: "Password is incorrect.",
    adminEmailError: "Your email is not an admin user",

    // baseUrl: 'https://burban.brandyuva.in/',
    baseUrl: 'https://writo.burbanmedia.com/',
    getCategoryEndPoint: 'category/get',
    addCategoryEndPoint: 'category/add',
    editCategoryEndPoint: 'category/edit',
    deleteCategoryEndPoint: 'category/delete',
    getLetterEndPoint: 'letter/get',
    addLetterEndPoint: 'letter/add',
    editLetterEndPoint: 'letter/edit',
    deleteLetterEndPoint: 'letter/delete',
    updateBannerEndPoint: 'banner/update',

    // Headers
    getApiHeader: {
        'Authorization': 'Bearer sJ4[pR3=bM5^gJ0]pS6.gI2$hV5*uS',
    },
    postApiHeader: {
        Authorization: 'Bearer sJ4[pR3=bM5^gJ0]pS6.gI2$hV5*uS',
        'Content-Type': 'application/json'
    },
    postFormDataApiHeader: {
        Authorization: 'Bearer sJ4[pR3=bM5^gJ0]pS6.gI2$hV5*uS',
        'Content-Type': 'multipart/form-data'
    }
}

export default Constants;